import React from "react";

import { Field } from "react-final-form";

import {
  required,
  maxLength,
  postalCode,
  composeField
} from "../lib/form-validators";

import { optionalStringParser } from "../lib/form-parsers";

import { TextInput } from "../components/ui/text-input";
import { DropDown } from "../components/ui/drop-down";

import _ from "lodash";

const AddressFields = ({ states }) => (
  <React.Fragment>
    <Field
      name="streetPrimary"
      validate={composeField(required, maxLength(128))}
      render={TextInput}
      placeholder="Street (Primary)"
    />

    <Field
      name="streetSecondary"
      validate={composeField(maxLength(128))}
      parse={optionalStringParser}
      render={TextInput}
      placeholder="Street (Secondary)"
    />

    <Field
      name="city"
      validate={composeField(required, maxLength(128))}
      render={TextInput}
      placeholder="City"
    />

    <div className="row">
      <div className="col-sm-6">
        <Field
          name="state"
          validate={composeField(required)}
          render={DropDown}
          items={_.map(states, (state, i) => (
            <option value={state} key={i}>
              {state}
            </option>
          ))}
          placeholder="Select State"
        />
      </div>
      <div className="col-sm-6">
        <Field
          name="postalCode"
          validate={composeField(required, postalCode, maxLength(10))}
          render={TextInput}
          placeholder="Postal Code"
        />
      </div>
    </div>
  </React.Fragment>
);

export { AddressFields };
